import React, { Component } from 'react';

class Overlay extends Component {
    render() {
        return (
            <div onClick={(event) => this.props.closeSideMenu(event)} className={this.props.theClass + ' ' + this.props.theState} style={{opacity: this.props.theStyle}}></div>
        );
    }
}

export default Overlay;